// REQ1956 checked
$(document).ready(function () {
  // Disable tooltip on mobile device
  if (/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {
    $(".toggle-password").removeAttr("original-title");
  }

  $(".toggle-password").click(function () {
    var parentElement = $(this).closest(".password-visibility-toggles");
    var inputToCheck = parentElement.attr("checkinput");

    if ($("#" + inputToCheck).attr("type") == "password") {
      $("#" + inputToCheck).attr("type", "text");
      parentElement.find(".toggle-password.on").hide();
      parentElement.find(".toggle-password.off").show();
    } else {
      $("#" + inputToCheck).attr("type", "password");
      parentElement.find(".toggle-password.on").show();
      parentElement.find(".toggle-password.off").hide();
    }
  });
});

function analysePassword(password) {
  if (password.length >= 8) {
    $("#passwordRequirements .minimalLength span.checkmark").addClass("check");
  } else {
    $("#passwordRequirements .minimalLength span.checkmark").removeClass(
      "check"
    );
  }
  if (password.search(/[A-Z]+/) >= 0) {
    $("#passwordRequirements .oneHigherCase span.checkmark").addClass("check");
  } else {
    $("#passwordRequirements .oneHigherCase span.checkmark").removeClass(
      "check"
    );
  }
  if (password.search(/[a-z]+/) >= 0) {
    $("#passwordRequirements .oneLowerCase span.checkmark").addClass("check");
  } else {
    $("#passwordRequirements .oneLowerCase span.checkmark").removeClass(
      "check"
    );
  }
  if (password.search(/[0-9]+/) >= 0) {
    $("#passwordRequirements .oneDigit span.checkmark").addClass("check");
  } else {
    $("#passwordRequirements .oneDigit span.checkmark").removeClass("check");
  }
}
